import template from './not-found-page.html';


const NotFoundPageComponent = {
    template,
    bindings: {},
};

export default NotFoundPageComponent;



// WEBPACK FOOTER //
// ../widgets/not-found-page/not-found-page.component.js